export const creditCards = state => state.billingData;
export const status = state => state.status;
export const bankAccount = state => state.bankAccount;
